import { Injectable } from "@angular/core";

import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { IWorkOrder } from "../../work-orders/models/IWorkOrder";
import { IProject } from "../../projects/shared/models/IProject";
import { DateTime } from "luxon";

const projectUrl = "/api/project";

@Injectable({
  providedIn: "root",
})
export class ProjectService {
  constructor(private http: HttpClient) {}

  getProjects(): Observable<IProject[]> {
    console.log("service call for projects");
    return this.http.get<IProject[]>(projectUrl);
  }
  getRecentProjects(userId: number): Observable<IProject[]> {
    return this.http.get<IProject[]>(`${projectUrl}/recent/${userId}`);
  }
  getProjectsWorkedInRange(
    userId: number,
    start: DateTime,
    end: DateTime
  ): Observable<IProject[]> {
    const params = new HttpParams()
      .set("start", start.toFormat("yyyy-MM-dd"))
      .set("end", end.toFormat("yyyy-MM-dd"));
    return this.http.get<IProject[]>(`${projectUrl}/recent/${userId}`, {
      params,
    });
  }
  getProjectsByWorkOrder(workOrderId: number): Observable<IProject[]> {
    const params = new HttpParams().set("workOrderId", workOrderId.toString());
    return this.http.get<IProject[]>(projectUrl, { params });
  }
  getProject(projectId: number): Observable<IProject> {
    return this.http.get<IProject>(`${projectUrl}/${projectId}`);
  }
  createProject(project: IProject): Observable<IProject> {
    return this.http.post<IProject>(projectUrl, project);
  }
  updateProject(project: IProject): Observable<IProject> {
    return this.http.put<IProject>(`${projectUrl}/${project.id}`, project);
  }
  deleteProject(projectId: number) {
    return this.http.delete<IProject>(`${projectUrl}/${projectId}`);
  }
  setProjectWorkOrders(
    projectId: number,
    workOrders: IWorkOrder[]
  ): Observable<any> {
    const workOrderIds = workOrders.map((wo) => wo.id);
    return this.http.post(
      `${projectUrl}/${projectId}/workorders`,
      workOrderIds
    );
  }
  setWorkOrderOrder(projectId: number, workOrders: IWorkOrder[]) {
    const workOrderIds = workOrders.map((wo) => wo.id);
    return this.http.put(
      `${projectUrl}/${projectId}/workorders/order`,
      workOrderIds
    );
  }
  /* *********************************
  ************************************
  Utility
  */
  sortByName(a: IProject, b: IProject) {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
      return -1;
    }
    if (a.name.toLowerCase() > b.name.toLowerCase()) {
      return 1;
    }
    return 0;
  }
}
